import styled from 'styled-components'

export const PnlCalendarEmpty: React.FC = () => (
  <Root>
    {Array.from({ length: 31 }, (_, index) => (
      <DayCell key={index} style={{ opacity: [0, 1].includes(index) ? 0 : 1 }}>
        &nbsp;
      </DayCell>
    ))}
  </Root>
)

const Root = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-template-rows: repeat(5, minmax(0, 1fr));
  height: 100%;
  min-height: 0;

  row-gap: 6px;
  column-gap: 6px;
`

const DayCell = styled.div`
  background: var(--backgroundA-2);

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 2px;
  padding: 4px 4px 6px;
  min-width: 0;
  border-radius: 4px;
  background: color-mix(in srgb, var(--backgroundA-3) 80%, transparent);
`
